import { render, staticRenderFns } from "./formsForm.vue?vue&type=template&id=6e53a20c"
import script from "./formsForm.vue?vue&type=script&lang=js"
export * from "./formsForm.vue?vue&type=script&lang=js"
import style0 from "./formsForm.vue?vue&type=style&index=0&id=6e53a20c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports